import React, { lazy } from 'react';
const SHOWCASE_IMG = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_600/v1778968305/Gemini_Generated_Image_i1m34ii1m34ii1m3_mdindk.png';
const products = [{
  badge: 'Nivel 1',
  name: 'Megapack Nutrición: Carrera Resuelta™',
  summary: 'El contenido central de toda la carrera, organizado por ejes curriculares y listo para estudiar.',
  tags: ['📚 6 Tomos', '🎁 6 Bonos'],
  image: SHOWCASE_IMG,
  color: 'rgb(240,253,244)',
  border: 'rgba(34,197,94,0.2)'
}, {
  badge: 'Nivel 2',
  name: 'Sistema Carrera Organizada™',
  summary: 'Todo el Megapack más un sistema para planificar, organizarte y no improvisar más.',
  tags: ['📚 Todo el Nivel 1', '🗂️ Sistema de estudio', '📝 2 Tomos extra'],
  image: SHOWCASE_IMG,
  color: 'rgb(220,252,231)',
  border: 'rgba(34,197,94,0.3)'
}, {
  badge: 'Nivel 3',
  name: 'Biblioteca Premium Nutrición™',
  summary: 'La versión completa. Todo el sistema más 11 editables premium para dominar cada materia.',
  tags: ['🏆 Todo el Nivel 2', '✏️ 11 Editables premium'],
  image: SHOWCASE_IMG,
  color: 'rgb(187,247,208)',
  border: 'rgba(34,197,94,0.4)'
}];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(240,253,244) 15%, rgb(220,252,231) 100%)'
  }} data-id="element-309">
      <div className="mx-auto max-w-4xl" data-id="element-310">
        {/* Label */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-green-700 mb-2" data-id="element-311">
          Tres niveles. Un solo objetivo.
        </p>

        {/* Heading */}
        <h2 className="text-2xl sm:text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-312">
          Elegí según dónde estás en la carrera
        </h2>

        <p className="text-center text-sm text-gray-500 mx-auto max-w-lg m-0 mb-8" data-id="element-313">
          Material construido sobre los planes de estudio oficiales de las
          principales universidades de Argentina.{' '}
          <strong className="text-gray-700" data-id="element-314">
            Organizado por ejes curriculares para que estudies lo correcto, en
            orden.
          </strong>
        </p>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6" data-id="element-315">
          {products.map(product => <div key={product.badge} className="rounded-xl border flex flex-col shadow-sm overflow-hidden" style={{
          borderColor: product.border,
          backgroundColor: product.color
        }} data-id="element-316">
              {/* Image — chica, solo referencial */}
              <div className="w-full h-16 overflow-hidden" data-id="element-317">
                <img src={product.image} alt={product.name} className="w-full h-full object-cover" loading="lazy" decoding="async" data-id="element-318" />
              </div>

              {/* Content */}
              <div className="px-3 py-3 flex flex-col gap-1.5" data-id="element-319">
                <span className="text-[10px] font-black text-green-700 uppercase tracking-widest" data-id="element-320">
                  {product.badge}
                </span>
                <p className="text-sm font-black text-gray-900 m-0 leading-snug" data-id="element-321">
                  {product.name}
                </p>
                <p className="text-xs text-gray-600 m-0 leading-relaxed" data-id="element-322">
                  {product.summary}
                </p>
                <div className="flex flex-wrap gap-1.5 mt-1" data-id="element-323">
                  {product.tags.map(tag => <span key={tag} className="text-[11px] font-semibold text-gray-700 bg-white/80 border border-green-200 rounded-full px-2.5 py-1" data-id="element-324">
                      {tag}
                    </span>)}
                </div>
              </div>
            </div>)}
        </div>

        {/* Footer referencia */}
        <p className="text-center text-xs sm:text-sm text-gray-500 mx-auto max-w-lg mb-6" data-id="element-325">
          👇{' '}
          <strong className="text-gray-700" data-id="element-326">
            Más abajo te mostramos en detalle qué incluye cada nivel, qué
            materias cubre y por qué está organizado así.
          </strong>
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(34,197,94), rgba(255,255,255,0))'
      }} data-id="element-327" />
      </div>
    </section>;
}